export default "__VITE_ASSET__DTJSDZTO__"